import { render, staticRenderFns } from "./UserPolicy.vue?vue&type=template&id=de452ce0&scoped=true&"
import script from "./UserPolicy.vue?vue&type=script&lang=js&"
export * from "./UserPolicy.vue?vue&type=script&lang=js&"
import style0 from "./UserPolicy.vue?vue&type=style&index=0&id=de452ce0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de452ce0",
  null
  
)

export default component.exports